"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POI = exports.POIListType = void 0;
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
const debugger_1 = __importDefault(require("../debugger/debugger"));
const poi_types_1 = require("../models/poi-types");
const is_defined_1 = require("../utils/is-defined");
var POIListType;
(function (POIListType) {
    POIListType["Active"] = "Active";
    POIListType["Gather"] = "Gather";
})(POIListType = exports.POIListType || (exports.POIListType = {}));
class POI {
    static init(lists, nodeInterface) {
        this.lists = lists;
        this.nodeInterface = nodeInterface;
    }
    static getAllListKeys() {
        return this.lists.map((list) => list.key);
    }
    static getActiveListKeys() {
        return this.lists.filter((list) => list.type === POIListType.Active).map((list) => list.key);
    }
    static validatePOIStatusForAllLists(pois, listKeys, statuses) {
        if (!this.hasAllKeys(pois, listKeys)) {
            return false;
        }
        for (const listKey of listKeys) {
            if (!statuses.includes(pois[listKey])) {
                return false;
            }
        }
        return true;
    }
    static hasValidPOIsAllLists(pois) {
        const listKeys = this.getAllListKeys();
        return this.validatePOIStatusForAllLists(pois, listKeys, [poi_types_1.TXOPOIListStatus.Valid]);
    }
    static hasValidPOIsActiveLists(pois) {
        const listKeys = this.getActiveListKeys();
        return this.validatePOIStatusForAllLists(pois, listKeys, [poi_types_1.TXOPOIListStatus.Valid]);
    }
    static findListsForNewPOIs(poisPerList) {
        const listKeys = this.getAllListKeys();
        if (!(0, is_defined_1.isDefined)(poisPerList)) {
            return listKeys;
        }
        const submittedStatuses = [poi_types_1.TXOPOIListStatus.TransactProofSubmitted, poi_types_1.TXOPOIListStatus.Valid];
        const needsSpendPOI = [];
        for (const listKey of listKeys) {
            const isUnsubmitted = !(0, is_defined_1.isDefined)(poisPerList[listKey]) || !submittedStatuses.includes(poisPerList[listKey]);
            if (isUnsubmitted) {
                needsSpendPOI.push(listKey);
            }
        }
        return needsSpendPOI;
    }
    static hasAllKeys(obj, keys) {
        return keys.every((key) => Object.prototype.hasOwnProperty.call(obj, key));
    }
    static shouldRetrieveCreationPOIs(txo) {
        if (!(0, is_defined_1.isDefined)(txo.blindedCommitment)) {
            return false;
        }
        if (!(0, is_defined_1.isDefined)(txo.poisPerList)) {
            return true;
        }
        return !POI.hasValidPOIsAllLists(txo.poisPerList);
    }
    static shouldRetrieveSpentPOIs(sentCommitment) {
        if (!(0, is_defined_1.isDefined)(sentCommitment.blindedCommitment)) {
            return false;
        }
        if (!(0, is_defined_1.isDefined)(sentCommitment.poisPerList)) {
            return true;
        }
        return !POI.hasValidPOIsAllLists(sentCommitment.poisPerList);
    }
    static shouldGenerateSpentPOIsSentCommitment(sentCommitment) {
        if (!(0, is_defined_1.isDefined)(sentCommitment.blindedCommitment)) {
            return false;
        }
        if (!(0, is_defined_1.isDefined)(sentCommitment.poisPerList)) {
            return true;
        }
        const listKeys = POI.findListsForNewPOIs(sentCommitment.poisPerList);
        return listKeys.length > 0;
    }
    static shouldGenerateSpentPOIsUnshieldEvent(unshieldEvent) {
        if (!(0, is_defined_1.isDefined)(unshieldEvent.blindedCommitment)) {
            return false;
        }
        if (!(0, is_defined_1.isDefined)(unshieldEvent.poisPerList)) {
            return true;
        }
        const listKeys = POI.findListsForNewPOIs(unshieldEvent.poisPerList);
        return listKeys.length > 0;
    }
    static isActiveForChain(chain) {
        try {
            return this.nodeInterface.isActive(chain);
        }
        catch (err) {
            return false;
        }
    }
    static async retrievePOIsForBlindedCommitments(chain, blindedCommitmentDatas) {
        if (!(0, is_defined_1.isDefined)(this.nodeInterface)) {
            throw new Error('POI node interface not initialized');
        }
        const listKeys = this.getAllListKeys();
        return this.nodeInterface.getPOIsPerList(chain, listKeys, blindedCommitmentDatas);
    }
    static async generateAndSubmitPOIAllLists(chain, poisPerList, railgunTxid, proofInputs, blindedCommitmentsOut, txidMerklerootIndex, railgunTransactionBlockNumber, progressCallback) {
        if (!(0, is_defined_1.isDefined)(this.nodeInterface)) {
            throw new Error('POI node interface not initialized');
        }
        const listKeys = POI.findListsForNewPOIs(poisPerList);
        for (let i = 0; i < listKeys.length; i += 1) {
            const listKey = listKeys[i];
            const progress = Math.round((i / listKeys.length) * 100);
            debugger_1.default.log(`Generating POIs for txid ${railgunTxid}: ${progress}% (List ${listKey})`);
            progressCallback(progress);
            await this.nodeInterface.generateAndSubmitPOI(chain, listKey, proofInputs, blindedCommitmentsOut, txidMerklerootIndex, railgunTransactionBlockNumber);
        }
    }
}
exports.POI = POI;
